<div class="app">
  <div class="split-pane">
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
